import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterOutlet } from '@angular/router';
import { NavbarComponent } from '../navbar/navbar.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { FooterComponent } from '../footer/footer.component';
import { RightSidebarComponent } from '../right-sidebar/right-sidebar.component';
import { NavigationlinkComponent } from '../navigationlink/navigationlink.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AppService } from '../../../app.service';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ChatboxSmartdocsComponent } from '../../pages/smart-docs/chatbox/chatbox-smartdocs.component';

@Component({
  selector: 'app-base',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    RightSidebarComponent,
    NavigationlinkComponent,
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    ChatboxSmartdocsComponent,
  ],
  templateUrl: './base.component.html',
  styleUrl: './base.component.scss'
})
export class BaseComponent implements OnInit {
  opened = false; // Bind this with mat-sidenav
  hasBeenOpened = false; // Persistent loading - once opened, keeps component alive in background
  isLoading: boolean = false;
  /** Show chatbox agent only after login (when auth token exists) */
  showChatboxAgent = false;
  public router = inject(Router);

  constructor(public appService: AppService, private dialog: MatDialog, private cdr: ChangeDetectorRef) {
    this.appService.rightNavToggle$.subscribe((x: any) => {
      setTimeout(() => {
        if (x === true) {
          this.isMargin = this.opened = true;
          this.hasBeenOpened = true;
          this.appService.ccpOpened.next(true);
        } else if (x === false) {
          this.isMargin = this.opened = false;
          this.appService.ccpOpened.next(false);
        }
      }, 0);
    });
  }

  closeCcp() {
    this.opened = false;
    this.isMargin = false;
    this.appService.ccpOpened.next(false);
    this.appService.rightNavToggle.next(false);
  }
  isMargin: boolean = false
  gracePeriodDays: any
  // ngOnInit(): void {
  //   let role: any = localStorage.getItem('roles')
  //   this.gracePeriodDays = localStorage.getItem('gracePeriodDays')
  //   if(this.gracePeriodDays !=  'null'){
  //     this.openNotification('Welcome to the dashboard!');
  //   }
  //   if (role === 'Client Agent') {
  //     this.loadChatWidget();
  //   }
  //   this.router.events.forEach((event) => {
  //     if (event instanceof RouteConfigLoadStart) {
  //       this.isLoading = true;
  //     } else if (event instanceof RouteConfigLoadEnd) {
  //       this.isLoading = false;
  //     }
  //   });
  // }
  ngOnInit(): void {
    // Defer chatbox so app shell (sidebar, navbar) renders first and doesn't freeze
    const token = !!localStorage.getItem('authToken');
    if (token) {
      setTimeout(() => {
        this.showChatboxAgent = true;
        this.cdr.markForCheck();
      }, 600);
    } else {
      this.showChatboxAgent = false;
    }
    let role: any = localStorage.getItem('roles');
    this.gracePeriodDays = localStorage.getItem('gracePeriodDays');
    const dialogShown = sessionStorage.getItem('dialogShown');
    if (this.gracePeriodDays !== 'null' && !dialogShown) {
      // this.openNotification('Welcome to the dashboard!');
      sessionStorage.setItem('dialogShown', 'true');
    }
    if (role === 'Client Agent') {
      // this.loadChatWidget();
    }
    this.router.events.forEach((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
      }
    });
  }
  // openNotification(message: string): void {
  //   this.dialog.open(NotificationDialogComponent, {
  //     width: '500px',
  //     data: { gracePeriodDays: this.gracePeriodDays }
  //   });
  // }
  loadChatWidget() {
    (function (w: any, d: Document, x: string, id: string) {
      const s = d.createElement('script');
      s.src = 'https://dtn7rvxwwlhud.cloudfront.net/amazon-connect-chat-interface-client.js';
      s.async = true;
      s.id = id;
      d.getElementsByTagName('head')[0].appendChild(s);
      w[x] = w[x] || function () {
        (w[x].ac = w[x].ac || []).push(arguments);
      };
    })(window, document, 'amazon_connect', 'e607975b-a928-43c3-9ac8-2060eb7774dc');
    (window as any).amazon_connect('styles', {
      iconType: 'CHAT',
      openChat: {
        color: '#ffffff',
        backgroundColor: '#1E569A',
      },
      closeChat: {
        color: '#ffffff',
        backgroundColor: '#1E569A',
      }
    });
    (window as any).amazon_connect(
      'snippetId',
      'QVFJREFIaWFZYXRVSlpIekdkUUg5YXhZenVQMktKRXNIWTVFQWpBYVErTEdzRnpvZHdIL2E0M0dtdlRoZFl5Skx0bkRBdDdoQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNTTkrWWJYQ3YwbVpLMjh2dkFnRVFnQ3VueHpNWmlLcS9jOGFxUXdnMDRRTm5KUUJtN2xQRVZIY0VyZmorZVNYY0tIUDJQMGtQUUFsV1pTSGY6OmdFKzhVaHVrOWp0VUZiMzhJMUxjZTdYQ2dqTWJJckN0VUlPdHFOcndwNTJ0SXdJMVViM2d5NkdhZ0Zlb3VDMHVMdzVmOE5GTi8vYUlLUHkzUks5OHNwempZY0ovcms5STR0OEZGbUxTZXpEVCtYWFpMNlhvN3p1UU1MNnhvb0R0cjV3bzlnbGZjTHZBa1VTdjh3RERWWjFSRENCY3RYMD0='
    );
    (window as any).amazon_connect('supportedMessagingContentTypes', [
      'text/plain',
      'text/markdown',
      'application/vnd.amazonaws.connect.message.interactive',
      'application/vnd.amazonaws.connect.message.interactive.response',
    ]);
    setTimeout(() => {
      const el = document.querySelector('.bPeSiV') as HTMLElement;
      if (el) {
        el.style.backgroundColor = '#1E569A';
      }
    }, 3000);
  }
}
